import { inject, Injectable, Injector } from '@angular/core';
import { ProductTypeEnum } from '../product-capture/model/enums/product-capture.enums';
import { CLNSettingsService, CustomProductSettingsService } from './model/product-settings/cln.settings';
import { PRODUCT_HIDDEN_SECTIONS } from './model/product-settings/product-sections.settings';

@Injectable()
export class ProductSettingsService {

  injector = inject(Injector);

  injectedSettings = new Map<ProductTypeEnum, any>();

  getHiddenSectionsByProductType(productType: string): string[] {
    return PRODUCT_HIDDEN_SECTIONS.get(productType);
  }

  getProductSettingsService(productType: string): CustomProductSettingsService {
    if (productType === ProductTypeEnum.CLN) {
      if (!this.injectedSettings.has(ProductTypeEnum.CLN)) {
        const clnSettingsService = this.injector.get(CLNSettingsService);
        this.injectedSettings.set(ProductTypeEnum.CLN, clnSettingsService);
      }

      return this.injectedSettings.get(ProductTypeEnum.CLN);
    }
  }

}
